<template>
  <v-autocomplete
    v-model="cityName"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    cache-items
    flat
    hide-no-data
    hide-details
    label="Cidade"
    @blur="changed"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import cityNames from "@/libraries/data/cityNames.js";
export default {
  name: "autocomplete-city",
  props: ["", "disabled","preSearch"],
  data() {
    return {
     cityName:"",
      loading: false,
      items: [],
      search: null,
      select: null,
    };
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
    preSearch(val){
        if (this.search != this.preSearch)
            this.search = this.preSearch;
        if (this.cityName != this.preSearch)
            this.cityName = this.preSearch;
        
    },
  },
  mounted(){
      //alert("moutend")
    if (this.search != this.preSearch)
        this.search = this.preSearch;
    if (this.cityName != this.preSearch)
        this.cityName = this.preSearch;
        
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.items = cityNames.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },

    changed() {
        this.$emit('changed', this.cityName)
    },
  },
};
</script>

<style scoped>
</style>